import { createUseStyles } from 'react-jss';
import { mechaColours } from '../mecha_components/mecha_styles';

export const useStyles = createUseStyles({
    formWrapper: {
        width: '100%'
    },
    postcode_confirmation_container: ({ isInvalid, isXs }) => ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        backgroundColor: mechaColours.backgroundWhite,
        borderRadius: '24px',
        padding: '32px',
        gap: isInvalid ? '0px' : '24px',
        '& > :nth-child(1)': {
            marginBottom: isInvalid ? '16px' : '0px'
        },
        '& > :nth-child(2)': {
            marginBottom: isInvalid ? '24px' : '0px'
        },
        '@media only screen and (max-width: 600px)': {
            padding: '16px'
        }
    }),
    postcode_button_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        '@media (max-device-width: 440px)': {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '100%',
            '& button': {
                width: '100%'
            }
        }
    }
});
